import { HomeConfig } from '@tenants/types/tenant';
import {
  getSubDomainUrlWithPath,
  RootDomain,
} from 'constants/domains';

export function createHomeConfig(rootDomain: RootDomain): HomeConfig {
  const homeConfig: HomeConfig = {
    heroVideo: '/commercial-hero-test.mp4',
    heroImage: '/next/assets/images/commercial/hero.jpg',
    heroImageAlt: 'Commercial real estate hero image',
    joinLink: getSubDomainUrlWithPath(rootDomain, 'www', '/become-an-advisor'),
    carouselImages: [
      '/next/assets/images/carousel/exp-commercial-1.mp4',
      '/next/assets/images/carousel/exp-commercial-2.jpg',
      '/next/assets/images/carousel/exp-commercial-3.jpg',
    ],
    testimonialBlock: {
      backgroundImage: '/next/assets/images/agent-search/exp-mobile-banner-white-flag.jpg',
      heading: 'Hear From Our Commercial Experts',
      testimonials: [
        {
          image: '/next/assets/images/in-service/inservice-agent1.jpg',
          alt: 'Agent 1',
          name: 'Brittany Sims',
          company: 'eXp Realty, Virginia',
          text: '"I\'m absolutely loving eXp. From the systems to the support, being able to do real estate while knowing I can build my vision is such an awesome feeling. Everything just feels very aligned."',
          index: 0,
        },
      ],
    },
    joinUsSection: {
      link: getSubDomainUrlWithPath(rootDomain, 'www', '/become-an-advisor'),
      title: 'Why Join eXp Commercial',
      title2: 'Commercial Brokerage Program',
      description: 'When you join eXp Commercial, you become part of a global family of agents and partners dedicated to transforming the commercial real estate experience. Learn more about how we empower our agents with world-class education, strategic partnership and stock awards.',
      imageUrl: '/next/assets/images/join-us-commercial.jpg',
      buttonText: 'Learn More',
    },
    contentCards: {
      sectionTitleParts: ['Commercial', 'Real Estate', 'Experts'],
      cards: [
        {
          title: 'Commercial Services',
          image: '/next/assets/images/content-cards/commercial-services.jpg',
          titleColor: 'rgba(255, 255, 255, 0.8)',
          backgroundColor: '#163259',
          content: 'From office spaces to industrial properties, our dedicated commercial experts provide comprehensive services tailored to your business needs. We specialize in all types of commercial real estate transactions.',
          link: getSubDomainUrlWithPath(rootDomain, 'www', '/services'),
          desktopTransform: 'rotate(-5deg) translateY(-1.5em)',
          tabletTransform: 'none',
          rounded: true,
          altText: 'Modern commercial building with glass facade.',
          buttonText: 'Explore Services',
        },
        {
          title: 'Commercial Listings',
          image: '/next/assets/images/content-cards/commercial-listings.jpg',
          titleColor: 'rgba(255, 255, 255, 0.7)',
          backgroundColor: '#6C82A0',
          content: 'Access a comprehensive database of commercial properties. Our platform provides detailed information about office spaces, retail locations, industrial properties, and more.',
          link: getSubDomainUrlWithPath(rootDomain, 'www', '/listings'),
          tabletTransform: 'translateY(3em)',
          translateYTablet: '50',
          altText: 'Commercial property listing showcase',
          buttonText: 'View Listings',
        },
        {
          title: 'Expert Advisors',
          image: '/next/assets/images/content-cards/expert-advisors.jpg',
          titleColor: '#0C0F24',
          backgroundColor: '#DAE0E7',
          content: 'Work with experienced commercial real estate professionals who understand your business needs. Our advisors specialize in various commercial property types and market segments.',
          link: getSubDomainUrlWithPath(rootDomain, 'www', '/experts'),
          desktopTransform: 'rotate(2deg) translateY(-1.5em)',
          tabletTransform: 'none',
          translateYDesktop: '-20',
          altText: 'Professional commercial real estate advisor in a meeting',
          buttonText: 'Find an Expert',
        },
        {
          title: 'Commercial Insights',
          image: '/next/assets/images/content-cards/commercial-insights.jpg',
          titleColor: '#0C0F24',
          backgroundColor: '#EEEEEE',
          content: 'Stay informed with the latest commercial real estate market trends, investment opportunities, and industry insights. Access valuable resources designed for commercial property investors and businesses.',
          link: getSubDomainUrlWithPath(rootDomain, 'www', '/insights'),
          desktopTransform: 'rotate(7deg) translateY(2em)',
          tabletTransform: 'translateY(3em)',
          translateYDesktop: '40',
          translateYTablet: '50',
          rounded: true,
          altText: 'Commercial real estate market analysis',
          buttonText: 'Read Insights',
        },
      ],
    },
    autoplaySlides: {
      title: 'Commercial Advisors',
      description: 'Our Advisor Directory helps you quickly find trusted experts with specialized knowledge across all commercial asset types and markets.',
      buttonText: 'Find a Commercial Advisor',
      buttonLink: getSubDomainUrlWithPath(rootDomain, 'www', '/insights'),
      slides: [
        {
          image: '/next/assets/images/exp-commercial/caleb-morrison.png',
          name: 'Caleb Morrison',
          description: 'eXp Commercial Advisor',
        },
        {
          image: '/next/assets/images/exp-footer-pic-us.jpg',
          name: 'John Doe 1',
          description: 'eXp Commercial Advisor',
        },
        {
          image: '/next/assets/images/hero-inservice-2.jpeg',
          name: 'John Doe 2',
          description: 'eXp Commercial Advisor',
        },
      ],
    },
  };

  return homeConfig;
}